import { createSlice } from "@reduxjs/toolkit";
import { fetchCruises } from "../thunks/fetchCruises";

const initialState = {
  cruisesList: [],
  totalPages: 0,
  isLoading: false,
  error: null
};

const cruiseSlice = createSlice({
  name: "cruises",
  initialState,
  reducers: {
    clearCruises: (state) => {
      state.cruisesList = [];
      state.totalPages = 0;
      state.error = null;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCruises.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCruises.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cruisesList = action.payload.cruises;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchCruises.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearCruises } = cruiseSlice.actions;
export default cruiseSlice.reducer;
